module.exports = __webpack_public_path__ + "img/yinglifenxi.f280bdd0.svg";